import { useSelector } from 'react-redux';

import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';
import { getKitById } from 'store/kits';
import { HideRecommendationItems } from '@repo/types';
import { ActionPlanRecommendation, BookmarkedItem } from 'types/ActionPlan';
import { Markdown, Typography } from 'components';
import {
  RecommendationItems,
  recommendationItemTypeToConfigKey,
} from '../RecommendationItems/RecommendationItems';

import styles from './Recommendations.module.scss';
import recommendationItemStyles from '../RecommendationItems/RecommendationItems.module.scss';

export const Recommendations = ({
  recommendations,
  actionId,
  activeBookmarks,
  showBookmarks,
}: {
  recommendations: ActionPlanRecommendation[];
  actionId?: number;
  activeBookmarks?: BookmarkedItem[];
  showBookmarks?: boolean;
}) => {
  const currentKitId = useCurrentKitAndTinyAccount().currentKitId;
  const currentKit = useSelector(getKitById(currentKitId));
  const partnerHideConfig =
    currentKit?.partner?.portal_config?.hide_recommendation_items;
  const practitionerHideConfig =
    currentKit?.practitioner?.portal_config?.hide_recommendation_items;

  const hideRecommendationItems: HideRecommendationItems | undefined =
    partnerHideConfig || practitionerHideConfig
      ? {
          ...practitionerHideConfig,
          ...partnerHideConfig,
        }
      : undefined;

  const filterItems = (items: ActionPlanRecommendation['items']) => {
    if (!hideRecommendationItems || !items?.length) return items ?? [];
    return items.filter(item => {
      const configKey =
        recommendationItemTypeToConfigKey[
          item.type as keyof typeof recommendationItemTypeToConfigKey
        ];
      return !hideRecommendationItems[configKey];
    });
  };

  return (
    <div className={styles.recommendationsContainer}>
      {recommendations.map(recommendation => {
        const visibleItems = filterItems(recommendation.items);

        return (
          <div className={styles.recommendation} key={recommendation.id}>
            {!!recommendation.display_title && (
              <Typography variant='heading-l'>
                {recommendation.display_title}
              </Typography>
            )}
            {!!recommendation.description && visibleItems.length > 0 && (
              <div className={styles.description}>
                <Markdown>{recommendation.description}</Markdown>
              </div>
            )}
            {visibleItems.length === 0 &&
            (recommendation.items?.length ?? 0) > 0 ? (
              <div
                className={`${recommendationItemStyles.itemsContainer} ${recommendationItemStyles.card}`}
              >
                <Typography variant='body-s'>
                  Consult your practitioner for personalized guidance on
                  supplement and probiotic recommendations
                </Typography>
              </div>
            ) : (
              <RecommendationItems
                items={visibleItems}
                activeBookmarks={activeBookmarks}
                actionId={actionId}
                showBookmarks={showBookmarks}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
